import { prepHandleEvent } from "./prepHandleEvent";
export function handleKeyUp(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;

  myApp.HandleKeyUp(event);
}
